import { registerPlugin } from '@capacitor/core';

export const AuthBrowser = registerPlugin('AuthBrowser');
